import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { isFunction, startsWith } from 'lodash';
import { FilterInterface } from '@/components/CustomFilter/FilterInterface';
import { PurchaseOrderFilterFlatInterface, PurchaseOrderFilterFlatInterfaceKeyType } from '@/models/PurchaseOrder';

@Component<PurchaseOrderFilters>({})
export default class PurchaseOrderFilters extends Vue {

  // #region @PropSyncs

  @PropSync('filters')
  protected internalFilters!: PurchaseOrderFilterFlatInterface;

  @PropSync('isShowingFilters')
  protected internalIsShowingFilters!: boolean;

  // #endregion

  // #region @Props

  @Prop({ default: 'purchase_order_filters' })
  protected filtersStorageKey!: string;

  @Prop({
    default: (): PurchaseOrderFilterFlatInterface => ({
      brand: [],
      expected_at_from: '',
      expected_at_to: '',
      master_data_status: [],
      status: [],
      supplier: [],
    })
  })
  protected filtersDefault!: PurchaseOrderFilterFlatInterface;

  @Prop({ default: '' })
  protected clearAllFiltersButtonText!: string;

  // #endregion

  // #region Props

  protected filterRefPrefix = 'filter_';

  protected loadedFilters = 0;

  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers

  protected onFilterLoaded(): void {
    this.loadedFilters += 1;

    if (this.isLoadingFilters === false) {

      this.showFiltersIfFilled();

      this.$emit('filters-loaded');
    }
  }

  protected onResetAllFilters() {
    Object.keys(this.$refs)
      .filter((refKey: string) => startsWith(refKey, this.filterRefPrefix))
      .map((refKey: string) => {
        if (this.$refs[refKey] && isFunction((this.$refs[refKey] as any).resetFilter)) {
          (this.$refs[refKey] as unknown as FilterInterface).resetFilter();
        };
      })
  }

  // #endregion

  // #region Helpers

  protected showFiltersIfFilled(): void {
    const filtersThatUserCanModify: PurchaseOrderFilterFlatInterfaceKeyType[] = [
      'brand',
      'expected_at_from',
      'expected_at_to',
      'master_data_status',
      'status',
      'supplier',
    ];

      for (let i = 0; i < filtersThatUserCanModify.length; i += 1) {
        const value = (this.internalFilters as any)[filtersThatUserCanModify[i]];
        if (value && value.length) {
          this.internalIsShowingFilters = true;
          break;
        }
      }
  }

  // #endregion

  // #region Getters / Setters

  protected get isLoadingFilters(): boolean {
    const numFilters = Object.keys(this.$refs)
      .filter((refKey: string) => startsWith(refKey, this.filterRefPrefix))
      .length;

    return numFilters > this.loadedFilters;
  }

  // #endregion
}
